// This optional code registers a service worker to enable offline caching.
// It only runs in production and when service workers are supported.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/
  )
);

export function register(): void {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    window.addEventListener('load', () => {
      if (isLocalhost) {
        // Validate service worker on localhost
        navigator.serviceWorker
          .register(swUrl)
          .then(reg => {
            if (process.env.NODE_ENV === 'development') {
            }
          })
          .catch(err => {
            if (process.env.NODE_ENV === 'development') {
              console.error('Service worker registration failed:', err);
            }
          });
      } else {
        // Register service worker
        navigator.serviceWorker
          .register(swUrl)
          .then(reg => {
            if (process.env.NODE_ENV === 'development') {
            }
          })
          .catch(err => {
            if (process.env.NODE_ENV === 'development') {
              console.error('Service worker registration failed:', err);
            }
          });
      }
    });
  }
}

export function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => registration.unregister())
      .catch(err => {
        if (process.env.NODE_ENV === 'development') {
          console.error('Service worker unregister failed:', err);
        }
      });
  }
} 
